import { configureStore } from "@reduxjs/toolkit";
import { useDispatch, useSelector, TypedUseSelectorHook } from "react-redux";
import { combineReducers } from "redux";

import authReducer from "../features/auth-module/authSlice";
import subscriptionReducer from "../features/subscription-module/susbscriptionSlice";
import planReducer from "../features/plan-management-module/planSlice";
import assignPlanReducer from "../features/asign-plan-module/assignSlice";
import leadReducer from "../features/lead-module/leadSlice";
import userReducer from "../features/user-management-module/userSlice";
import reportReducer from "../features/generate-report-module/reportSlice";
import chargingOutputReducer from "../features/charging-output-module/chargingOutputSlice";
import addWhiteLabelReducer from "../features/add-white-label-module/addWhiteLabelSlice";
import profileReducer from "../features/profile-module/profileSlice";
import dashboardReducer from "../features/dashboard-module/dashboardSlice";
import estimatorHookReducer from "../features/estimator-hook-module/estimatorHookSlice";
import estimatorReducer from "../features/estimator-module/estimatorSlice";
import commonReducer from "../features/common-module/commonSlice";
import fleetReportReducer from '../features/fleet-report-module/fleetReportSlice';

// Combine reducers
const rootReducer = combineReducers({
  auth: authReducer,
  subscription: subscriptionReducer,
  planManagement: planReducer,
  assignPlan: assignPlanReducer,
  lead: leadReducer,
  users: userReducer,
  report: reportReducer,
  chargingOutput: chargingOutputReducer,
  addWhiteLabel: addWhiteLabelReducer,
  profile: profileReducer,
  dashboard: dashboardReducer,
  estimatorHook: estimatorHookReducer,
  estimator: estimatorReducer,
  common: commonReducer,
  fleetReport: fleetReportReducer,
});

// Create and export the store
export const store = configureStore({
  reducer: rootReducer,
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// Typed hooks for usage in components
export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
